<div class="db-hosted-trial-started-wrap">
  <div class="db-hosted-trial-started">
    <div>
      <div class="header-content sub-header">
        <span [innerHTML]="subHeader" class="mr4" [class.mb4]="icon"></span>
        <ng-lottie
          *ngIf="icon"
          [options]="lottieConfig"
          style="width: 36px; height: 36px; display: block"
        ></ng-lottie>
      </div>
      <div class="header-content header">
        <span [innerHTML]="'text_hostedTrialStarted' | dbText"></span>
      </div>
      <ul class="db-demo-success__points">
        <li *ngFor="let point of points">
          <img class="db-checkmark" src="assets/images/icons/checkmark-new.svg" alt="checkmark"/>
          <span [innerHTML]="point"></span>
        </li>
      </ul>
    </div>
    <div class="db-platform-account-upgraded__buttons-wrap text-center mt30">
      <a class="ds-btn-black ds-btn-max rectangle" (click)="proceed()">
        <span>{{icon ? 'Preview & edit' : 'Proceed'}}</span></a>
    </div>

  </div>
  <div class="db-testing-reviews">
    <div class="db-review">
      <img src="assets/images/cancel-1wf/quote.svg"/>
      <p class="db-review-text">10Web is a game-changer! The
        <span>Al-powered<br/> builder is incredibly intuitive</span> and makes customization a breeze.</p>
      <div class="db-user"><p>Fatima Aftab</p> <span>10Web user</span></div>
    </div>
    <div class="db-footer">
      <p><span class="doted">1.5M+</span> websites created<br/> with 10Web AI.</p>
      <db-trustpilot [version]="'micro-combo'" [isDark]="true"></db-trustpilot>
    </div>
  </div>
</div>
